import React, { Component } from "react";
import axios from "axios";
import Conf from "./Conf";
import Navbar from "./components/Navbar";
import { goLogin, getPermission, getStampTime } from "./js/main";

import BackupIcon from "@material-ui/icons/Backup";
import DateFnsUtils from "@date-io/date-fns";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import CropOriginalIcon from "@material-ui/icons/CropOriginal";
import PageHead from "./components/PageHead";

const page_title = "คลังใบเสร็จ";
export default class Repository extends Component {
  state = {
    form: {
      limit: 500,
    },
    keyword: "",
  };
  componentDidMount() {
    this.getAuth();
  }
  async getAuth() {
    var bill_id = this.props.match.params.id;
    var cookie = localStorage.getItem(Conf.cookieName);
    cookie = JSON.parse(cookie);
    if (cookie && cookie.token) {
      var auth = await getPermission(cookie.token);
      if (auth === false) goLogin(Conf.frontendURL + "newbill/" + bill_id);
      else {
        var result = await this.getResult();
        this.setState({
          profile: auth.profile,
          result: result.bills,
          count: result.count,
        });
      }
    } else goLogin(Conf.frontendURL + "newbill/" + bill_id);
  }
  async setDate(d) {
    return new Promise(async (resolve) => {
      var stamp = null;
      if (!d) stamp = await getStampTime();
      else stamp = await getStampTime(d);
      stamp = new Date(stamp.iso_date).toISOString();
      resolve(stamp);
    });
  }

  getResult() {
    return new Promise(async (resolve) => {
      var { form } = this.state;
      if (!form.startDate) form.startDate = await this.setDate();
      if (!form.endDate) {
        form.endDate = await this.setDate();
        // var currentDate = new Date();
        // currentDate.setDate(currentDate.getDate() + 1);
        // form.endDate = await this.setDate(currentDate);
      }
      var endDate = JSON.parse(JSON.stringify(form.endDate));
      var dt = new Date(endDate);
      endDate = dt.setDate(dt.getDate() + 1);
      endDate = await this.setDate(endDate);
      var query = null;
      var keyword = null;
      if (this.state.keyword && this.state.keyword.trim() !== "") {
        // keyword = this.state.keyword;
        query = {
          $or: [
            {
              bill_id: {
                $regex: ".*" + this.state.keyword.trim() + ".*",
              },
            },
            {
              "payer.name": {
                $regex: ".*" + this.state.keyword.trim() + ".*",
                $options: "i",
              },
            },
          ],
        };
      } else {
        query = {
          $and: [
            { transactionDateandTime: { $gte: form.startDate } },
            { transactionDateandTime: { $lte: endDate } },
          ],
        };
      }
      var cookie = localStorage.getItem(Conf.cookieName);
      cookie = JSON.parse(cookie);
      console.log(query);
      axios
        .post(
          Conf.digitalpayBackend + "bill",
          {
            query: query,
            limit: form.limit,
            keyword: keyword,
          },
          { headers: { Authorization: cookie.token } }
        )
        .then(async (res) => {
          resolve(res.data);
        });
    });
  }

  changeDate(date, id) {
    var { form } = this.state;
    form[id] = date;
    form.skip = 0;
    console.log(form);
    this.setState({ form }, async () => {
      var result = await this.getResult();
      this.setState({ result: result.bills, count: result.count });
    });
  }
  changeFilter(keyword) {
    keyword = keyword.trim();
    this.setState({ keyword }, async () => {
      var result = await this.getResult();

      this.setState({ result: result.bills, count: result.count });
    });
  }
  resultFilter() {
    var { result, keyword } = this.state;
    var r = JSON.parse(JSON.stringify(result));
    if (keyword !== "") {
      r = r.filter(
        (j) =>
          j.bill_id.indexOf(keyword) > -1 ||
          j.payerName.indexOf(keyword) > -1 ||
          j.payer.name.indexOf(keyword) > -1
      );
      return r;
    } else return r;
  }
  goBill(id) {
    this.props.history.push(process.env.PUBLIC_URL + "/bill/" + id);
  }
  render() {
    const { profile, form, count } = this.state;
    return (
      <div>
        {profile && (
          <div>
            <Navbar />
            <main className="content">
              <PageHead
                icon={<BackupIcon style={{ fontSize: "2rem" }} />}
                title={page_title}
                profile={profile}
              />
              <PickDate
                changeDate={(date, id) => this.changeDate(date, id)}
                startDate={form.startDate}
                endDate={form.endDate}
                changeFilter={(keyword) => this.changeFilter(keyword)}
              />
              <br />
              <div style={{ fontWeight: 400, fontSize: "1.2rem" }}>
                Found : {count} bill(s)
              </div>
              <br />
              <FileList
                result={this.resultFilter()}
                goBill={(id) => this.goBill(id)}
              />
            </main>
          </div>
        )}
      </div>
    );
  }
}
class FileList extends React.Component {
  render() {
    const { result, goBill } = this.props;
    return (
      <>
        <Grid container spacing={1}>
          {result.map((bill, key) => (
            <Grid
              item
              key={key}
              xs={6}
              md={3}
              lg={2}
              style={{ textAlign: "center" }}
            >
              <Button
                fullWidth
                style={{ padding: "0px 0px" }}
                onClick={() => goBill(bill.bill_id)}
              >
                <Box
                  boxShadow={1}
                  style={{
                    background: "#fff",
                    padding: "20px 5px",
                    margin: "0px",
                    width: "100%",
                    height: "190px",
                  }}
                >
                  <CropOriginalIcon style={{ fontSize: "5rem" }} />
                  <div
                    style={
                      bill.canceled && bill.canceled.status === true
                        ? { color: "#f00" }
                        : {}
                    }
                  >
                    {bill.bill_id}
                  </div>
                  {bill.payer && (
                    <div
                      style={
                        bill.canceled && bill.canceled.status === true
                          ? { color: "#f00", fontSize: ".8rem" }
                          : { fontSize: ".8rem" }
                      }
                    >
                      {bill.payer.name}
                    </div>
                  )}
                  {bill.canceled && (
                    <div
                      style={
                        bill.canceled && bill.canceled.status === true
                          ? { color: "#f00", fontSize: ".8rem" }
                          : { fontSize: ".8rem" }
                      }
                    >
                      {bill.canceled.remark}
                    </div>
                  )}
                  <div style={{ fontSize: ".7rem" }}>{bill.bill_date}</div>
                </Box>
              </Button>
            </Grid>
          ))}
          {result.length === 0 && (
            <Grid
              item
              xs={12}
              style={{ paddingTop: "80px", textAlign: "center", color: "#999" }}
            >
              No bill found
            </Grid>
          )}
        </Grid>
      </>
    );
  }
}

class PickDate extends React.Component {
  changeKeyword(e) {
    this.props.changeFilter(e.target.value);
  }
  render() {
    const { changeDate, startDate, endDate } = this.props;

    return (
      <div>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <KeyboardDatePicker
                margin="normal"
                id="startDate"
                label="From"
                format="yyyy-MM-dd"
                value={startDate}
                onChange={(date) => changeDate(date, "startDate")}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                style={{ marginRight: "10px" }}
              />
              <KeyboardDatePicker
                margin="normal"
                id="endDate"
                label="To"
                format="yyyy-MM-dd"
                value={endDate}
                onChange={(date) => changeDate(date, "endDate")}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
              />
            </Grid>

            <Grid item xs={12} md={6} style={{ paddingTop: "20px" }}>
              <TextField
                id="keyword"
                label="Search"
                variant="outlined"
                placeholder="Keyword..."
                InputLabelProps={{ shrink: true }}
                // onChange={(e) => this.changeKeyword(e)}
                onKeyUp={(e) => e.key === "Enter" && this.changeKeyword(e)}
                fullWidth
              />
            </Grid>
          </Grid>
        </MuiPickersUtilsProvider>
      </div>
    );
  }
}
